import { Vue } from 'vue-class-component';

export default class LanguageMixin extends Vue {
  texts = {};

  t(text: string) {
    return this.texts[text] ?? text;
  }
}
